<template>
  <div class="page-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {
  },
}
</script>

<style scoped>
.page-container {
  padding-top: 70px; /* 为固定导航栏预留空间 */
}
</style>
